import { render, staticRenderFns } from "./pedido.vue?vue&type=template&id=86f35dde&"
import script from "./pedido.vue?vue&type=script&lang=ts&"
export * from "./pedido.vue?vue&type=script&lang=ts&"
import style0 from "./pedido.vue?vue&type=style&index=0&id=86f35dde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
